import React, { useEffect, useState } from "react";
import { Modal, InputNumber, message } from "antd";
import { apiError, fmtPeriod } from "./utils";

const axios = require("axios").default;

/** Seçili günlerin kapsadığı her ay için 1 USD = ? PHP kuru (manuel) */
const FxModal = ({ open, periods, fx, onClose, onSaved }) => {
  const [values, setValues] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setValues({ ...fx });
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const save = async () => {
    const changed = periods.filter((p) => values[p] && values[p] !== fx[p]);
    if (periods.some((p) => values[p] !== undefined && values[p] !== null && !(values[p] > 0))) {
      message.warning("Kur sıfırdan büyük olmalı.");
      return;
    }
    setSaving(true);
    try {
      for (const p of changed) {
        await axios.put(`payroll/fx/${p}`, { php_per_usd: values[p] });
      }
      message.success("Kur kaydedildi.");
      onSaved();
    } catch (err) {
      message.error(apiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal title="Döviz Kuru Ayarları" visible={open} onCancel={onClose} onOk={save} okText="Kuru Kaydet" confirmLoading={saving}>
      <p style={{ color: "#666", marginTop: 0 }}>
        Her ay için 1 USD karşılığı PHP değerini girin. Yalnızca henüz onaylanmamış maaşlar yeni kurdan etkilenir;
        onaylı bordroların kuru sabit kalır.
      </p>
      {periods.map((p) => (
        <div key={p} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
          <span style={{ textTransform: "capitalize" }}>{fmtPeriod(p)}</span>
          <InputNumber
            min={0.01}
            step={0.01}
            style={{ width: 180 }}
            addonBefore="1 USD ="
            addonAfter="PHP"
            placeholder="Girilmedi"
            value={values[p]}
            onChange={(v) => setValues({ ...values, [p]: v })}
          />
        </div>
      ))}
      <div style={{ fontSize: 12, color: "#888" }}>Örnek: 12.050 PHP / 62 = 194,35 USD. Kurlar canlı kur servisine bağlı değildir.</div>
    </Modal>
  );
};

export default FxModal;
